import React from 'react';

function normalizePath(path: string): string {
    // add trailing slash if not present
    if (!path.endsWith('/')) {
        return `${path}/`;
    }
    return path;
}

export const VersionSelector = () => {
    const selectedVersion = normalizePath(window.location.pathname);

    const options = [
        {label: 'ver. 2024-01', url: '/dev-portal/api-reference/2024-01/'},
        {label: 'ver. 2022-03', url: '/dev-portal/api-reference/2022-03/'},
    ];

    const doRedirect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedUrl = e.target.value;
        if (selectedUrl && selectedUrl !== selectedVersion) {
            window.location.href = selectedUrl;
        }
    };
    return (
        <select className="ud-select ud-text-lg" value={selectedVersion} onChange={doRedirect}>
            {options.map((option) => {
                const isSelected = selectedVersion === option.url;
                return (
                    <option key={option.url} value={option.url} disabled={isSelected}>
                        {option.label}
                    </option>
                );
            })}
        </select>
    );
};
